import script from "./LessonView.vue?vue&type=script&setup=true&lang=js"
export * from "./LessonView.vue?vue&type=script&setup=true&lang=js"

import "./LessonView.vue?vue&type=style&index=0&id=25cfd078&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cfd078"]])

export default __exports__